import React from "react";
import "./Home.css";
import Search from "./components/Search";
import VideoField from "./components/VideoField";
import HomeInfoBar from "./components/HomeInfoBar";
import TourCard from "./components/TourCard";
import HomeTop from "./components/HomeTop"
import Footer from "./components/Footer"
import Workers from "./components/Workers"

function index() {
  return (
    <div className="home">
      <HomeTop/>
      <Search />
      <VideoField />
      <TourCard/>
      <Workers/>
      <HomeInfoBar />
      <Footer/>
    </div>
  );
}

export default index;
